import { u_, csl } from "@pressmedia/webappbase";

export default {
	// ajax通信エラーの際のコールバック
	ajaxErrorCallback(methodName, xhr, textStatus, errorThrown) {
		let err;
		
		if(methodName instanceof XMLHttpRequest) {
			const args = u_.getAsArray(arguments);
			xhr = args.shift();
			textStatus = args.shift();
			errorThrown = args.shift();
			methodName = "";
		}
		
		!!xhr.responseText && ( xhr.responseText = xhr.responseText.trim() );
		if(xhr.responseText) {
			const tmp = /([^{]*)(\{[\S\s]*\}$)/.exec(xhr.responseText);
			if(tmp) {
				try {
					err = {
						method: methodName,
						response: JSON.parse(tmp[2])
					};
					
					if( u_.hasProperty(err.response, "error") ) {
						err = Object.assign(err.response.error, err);
						delete err.response.error;
						
						if( !u_.isString(err.type) && !isNaN(err.code) ) {
							err.type = String(err.code);
						}
						if(!err.messages || typeof err.messages !== "object") {
							err.messages = u_.isString(err.messages) ? [err.messages] : [];
						}
					} else
					if(!tmp[1]) {
						csl.warn("response has no `error`.", err);
					}
					
					!!tmp[1] && ( tmp[1] = tmp[1].trim() );
					if(tmp[1]) {
						err.type = "INTERNAL SERVER ERROR";
						if( Array.isArray(err.messages) ) {
							err.messages.unshift(tmp[1]);
						} else
						if(err.messages && typeof err.messages === "object") {
							err.messages.SERVER = tmp[1];
						} else {
							err.messages = [tmp[1]];
						}
					}
					
					if( err.type && u_.isFunction( this.errorCallbacks[err.type] ) ) {
						this.errorCallbacks[err.type].apply(this, [
							err.messages,
							methodName,
							err.code,
							err.type
						]);
					} else {
						this.errorCallbacks.def.apply(this, [
							err.messages,
							methodName,
							err.code,
							err.type
						]);
					}
					
				} catch(e) {
					err = undefined;
				}
			}
		}
		
		if(!err) {
			this.app.ajaxErrorCallback(xhr, textStatus, errorThrown);
			
			err = {
				code: xhr.status,
				messages: [textStatus, xhr.responseText],
				method: methodName
			};
		}
		
		return err;
	},
	
	// サーバーから（明示的に）エラーが返って来た場合のコールバック
	errorCallbacks: {
		def(messages, methodName, errcode, errtype) {
			let dispMsg = "";
			
			if( errtype && u_.isString(errtype) ) {
				if(u_.isNumber(errcode) && errcode !== 997) {	// 997: WARNING
					if(errcode < 999) {
						errtype += " ERROR";
					} else {
						errtype = "ERROR " + errtype;
					}
				}
				dispMsg += "<strong>" + errtype + "</strong><br>";
			}
			
			csl.warn(errtype, errcode, methodName, messages);
			
			if(this.app._environment === "prod") {
				dispMsg += "エラーが発生しました";
			} else
			if(messages && typeof messages === "object") {
				if( Array.isArray(messages) ) {
					dispMsg += messages.join("<br>");
				} else {
					dispMsg += Object.keys(messages).map(k => {
						return `${k}: ${messages[k]}`;
					}).join("<br>");
				}
			}
			
			return this.alert(dispMsg);
		},
		
		INPUT(messages, methodName, errcode, errtype) {
			if( u_.isObject(messages) ) {
				return this.showPrompt(messages);
			} else
			if( Array.isArray(messages) ) {
				return this.alert( messages.join("<br>") );
			} else {
				return this.errorCallbacks.def.apply(this, arguments);
			}
		},
		
		FILE_UPLOAD(messages, methodName, errcode, errtype) {
			return this.alert( Object.keys(messages).map(k => {
				return messages[k];
			}).join("<br>") );
		}
	}
};
